/**
 * Data Transfer Object (DTO) for project status.
 * Represents the wire format used by the backend API.
 */

/**
 * Base DTO enum for project status.
 * Matches backend enum values exactly.
 */
export enum ProjectStatusDTO {
  TENTATIVE = 'TENTATIVE',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

/**
 * Type alias for project status in API requests.
 */
export type ProjectStatusRequest = ProjectStatusDTO;

/**
 * Type alias for project status in API responses.
 */
export type ProjectStatusResponse = ProjectStatusDTO;
